module.exports = __webpack_public_path__ + "media/assets/faria_products/PEA-EDE-7d4b989cea9a350cbb7d64de08b8f144a5eb2001f888ba866c77ed55f3b71771.png";